export const RegularExpressions = {
	ID: new RegExp(/^$|^(?=.*[a-zA-Z0-9])[a-zA-Z0-9].*$/),
	Name: new RegExp(/^$|^(?=.*[a-zA-Z])[a-zA-Z].*$/),
	Numeric: new RegExp(/^(0|[1-9][0-9]*)$/),
	SSN: new RegExp(/^[0-9]+(-[0-9]+)*$/),
};
